import History from "../models/History";

const HistoryStore = History.create();

export default HistoryStore;
